<template>
  <div class="request-list-container" style="overflow: hidden;">
    <ModalMulti v-if="$store.state.notifStore.multi_modal" />
    <SearchModal v-if="$store.state.notifStore.search_modal" />
    <div class="horizontal p-2" style="width: 100%;">
      <div class="column15 text-red">Dokumen Expired</div>
      <div class="column15 cursor-pointer" @click="multipleSelection">
        Multiple Selection
      </div>
      <div class="column10 cursor-pointer" @click="massCreatePq">
        Filter
      </div>
      <!-- <div class="cursor-pointer" @click="readAll()">Read All</div> -->
    </div>
    <div class="request-list-wrapper">
      <div class="request-table">
        <div class="request-table-list cursor-pointer" v-for="(item, index) in legal_doc" :key="index">
          <div class="mb10">
            <div class="flex-space-between" style="width: 100%">
              <div :style="`color: black`">
                {{ item.nama_vendor }}, {{ item.alias_profile }} -
                <span v-html="checkExpired(item.docs)"></span>
                <!-- <span
                  :class="
                    checkExpired(item.docs) == 'Expired'
                      ? 'text-red'
                      : 'legend-satisfy'
                  "
                  >{{ checkExpired(item.docs) }}</span
                > -->
              </div>
              <div class="horizontal" @click="sendMail(item)">
                <!-- <span><i class="fas fa-bars"></i></span> -->
                <span class="mr10 ml10"><i class="far fa-envelope"></i></span>
              </div>
            </div>

            <div class="horizontal" :style="`color: black; font-size: 12px`" v-for="(list, j) in item.docs" :key="j">
              <div class="column40">
                {{ list.name }}
              </div>
              <div class="column10">
                -
              </div>
              <div class="column30">Tanggal Berakhir: {{ list.date }}</div>
              <div :class="`column20 ${list.status == 'Expired' ? 'text-red' : 'legend-satisfy'
                }`
                ">
                {{ list.status }} ({{ list.available }} Hari)
              </div>
            </div>
            <!-- <div class="horizontal" :style="`color: black; font-size: 12px`">
              <div class="column40">
                Nama Document 2
              </div>
              <div class="column10">
                -
              </div>
              <div class="column30">Tanggal Berakhir: tanggal_berakhir</div>
              <div class="column20 text-red">Expired (-15 Hari)</div>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="request-pagination">
        <div class="mlp-pagination-wrapper-level1">
          <b-pagination
            aria-controls="isupplier-table"
            v-model="page"
            :total-rows="totalItems"
            :per-page="perPage"
            align="fill"
            class="mlp-pagination"
          ></b-pagination>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  components: {
    ModalMulti: () => import('@/components/PqLegalMultySelection.vue'),
    SearchModal: () => import('@/components/modal/MassEmail.vue'),
  },
  data() {
    return {}
  },
  created() {
    this.$store.dispatch('notifStore/checkDocument')
  },
  // mounted() {
  //   this.$store.dispatch('notifStore/checkDocument')
  // },
  computed: {
    legal_doc() {
      const data = this.$store.state.notifStore.legal_doc

      return data
    },
  },
  methods: {
    async showDetail(url, id, status) {
      const route = url.split('#')[1]

      if (!status) {
        await this.$store.dispatch('notifStore/updateNotif', {
          id,
          name: this.$store.state.currentUser,
          role_id: this.$store.state.role_id,
          open_by: this.$store.state.currentUser,
          last_open: this.$store.state.currentUser,
          status,
        })
      } else {
        await this.$store.dispatch('notifStore/updateNotif', {
          id,
          name: this.$store.state.currentUser,
          role_id: this.$store.state.role_id,
          last_open: this.$store.state.currentUser,
          status,
        })
      }

      await this.$router.push(route)
    },

    sendMail(item) {
      if (
        confirm(
          `
            Buat PQ Legal vendor: 
            "${item.nama_vendor}, ${item.alias_profile}"
          `
        )
      ) {
        this.createPqManual(item)
      } else {
        //do nothing
      }
    },

    createPqManual(item) {
      this.$store.dispatch('notifStore/createPqManual', item)
    },

    massCreatePq() {
      this.$store.commit('notifStore/UPDATE_DATA', {
        name: 'search_modal',
        value: true,
      })
    },

    multipleSelection() {
      if (this.legal_doc.length > 0) {
        this.$store.commit('notifStore/UPDATE_DATA', {
          name: 'multi_modal',
          value: true,
        })
      } else {
        alert('tidak ada data')
      }
    },
  },
}
</script>
